module.exports = __webpack_public_path__ + "salesforce.png?a9bfe078e30557cfbd15c9ad027d74c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/salesforce.png
// module id = 192
// module chunks = 0